import api from '../config/axios';
import config from '../config/environment';
import { testProductionCORS, getCORSRecommendations } from './productionCorsTest';

export const debugConnection = async () => {
  console.log('=== Connection Debug Information ===');
  console.log('Environment Info:', config.getEnvironmentInfo());
  console.log('Current API URL:', api.defaults.baseURL);
  console.log('Current origin:', window.location.origin);
  
  // If in production, run production CORS tests
  if (config.isProduction) {
    console.log('\n=== Running Production CORS Tests ===');
    const corsResults = await testProductionCORS();
    
    if (corsResults.tests.some(test => test.status === 'FAIL')) {
      console.log('\n=== CORS Recommendations ===');
      const recommendations = getCORSRecommendations();
      console.log('Backend Requirements:');
      recommendations.backend.forEach(rec => console.log('  -', rec));
      console.log('\nFrontend Requirements:');
      recommendations.frontend.forEach(rec => console.log('  -', rec));
      console.log('\nDeployment Requirements:');
      recommendations.deployment.forEach(rec => console.log('  -', rec));
    }
    
    return;
  }
  
  // Development mode tests
  console.log('\n=== Development Mode Tests ===');
  
  // Test different endpoints
  const endpoints = [
    '/',
    '/api',
    '/api/admin/login',
    '/health',
    '/api/health'
  ];
  
  for (const endpoint of endpoints) {
    try {
      console.log(`\nTesting endpoint: ${endpoint}`);
      const response = await api.get(endpoint);
      console.log(`✅ Success (${response.status}):`, response.data);
    } catch (error) {
      console.log(`❌ Failed:`, {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        code: error.code
      });
      
      // Special handling for different error types
      if (error.response?.status === 404) {
        console.log(`   ℹ️  404 - Endpoint doesn't exist (this is normal)`);
      } else if (error.response?.status === 401) {
        console.log(`   ℹ️  401 - Endpoint exists but requires authentication (this is good!)`);
      } else if (error.code === 'ERR_NETWORK') {
        console.log(`   🔴 Network Error - Server might not be running`);
      }
    }
  }
  
  // Test OPTIONS request (preflight)
  try {
    console.log('\nTesting OPTIONS request (preflight)...');
    const response = await api.options('/api/admin/login');
    console.log('✅ OPTIONS request successful:', response.status);
  } catch (error) {
    console.log('❌ OPTIONS request failed:', error.message);
    if (error.response?.status === 404) {
      console.log('   ℹ️  404 - Endpoint doesn\'t exist (this is normal)');
    }
  }
  
  // Test POST request to login endpoint
  try {
    console.log('\nTesting POST request to login endpoint...');
    const response = await api.post('/api/admin/login', { email: 'test@test.com', password: 'test' });
    console.log('✅ POST request successful:', response.status);
  } catch (error) {
    console.log('❌ POST request failed:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText
    });
    
    if (error.response?.status === 401) {
      console.log('   ℹ️  401 - Login endpoint exists but credentials are invalid (this is expected)');
    } else if (error.response?.status === 404) {
      console.log('   ℹ️  404 - Login endpoint doesn\'t exist');
    }
  }
  
  console.log('\n=== End Debug Information ===');
};

export const testBackendConnection = async () => {
  try {
    // Try direct fetch to see if it's a proxy issue
    console.log('Testing direct fetch to backend...');
    const response = await fetch('http://localhost:5000/api/health');
    console.log('Direct fetch result:', response.status, response.statusText);
    return { success: true, status: response.status };
  } catch (error) {
    console.log('Direct fetch failed:', error.message);
    return { success: false, error: error.message };
  }
};

export const testProxyConnection = async () => {
  try {
    console.log('Testing proxy connection...');
    const response = await fetch('/api/health');
    console.log('Proxy fetch result:', response.status, response.statusText);
    return { success: true, status: response.status };
  } catch (error) {
    console.log('Proxy fetch failed:', error.message);
    return { success: false, error: error.message };
  }
}; 

export const testAdminLogin = async () => {
  try {
    const response = await api.post('/api/admin/login', {
      email: 'admin@gmail.com',
      password: 'admin@1',
    });
    console.log('Admin login test successful:', response.data);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    console.error('Admin login test failed:', error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data || error.message,
      status: error.response?.status,
    };
  }
}; 